import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

export function Name({ children }: PropsWithChildren) {
  return <NameComponent>{children}</NameComponent>;
}

export const NameComponent = styled.div`
  flex-shrink: 0;
  font-size: ${({
    theme: {
      itemNameFontStyle: { fontSize }
    }
  }) => fontSize}px;
  font-weight: ${({
    theme: {
      itemNameFontStyle: { fontWeight }
    }
  }) => fontWeight};
  line-height: 1.31;
  text-align: center;
  color: #111111;
  text-transform: ${({
    theme: {
      itemNameFontStyle: { textTransform }
    }
  }) => textTransform};
  display: flex;
  align-items: center;
  justify-content: center;
`;
